const PENDING_ORDER_KEY = "lianne_pending_order";
const PENDING_ORDER_TTL_MS = 30 * 60 * 1000;

export const savePendingVNPayOrder = (response, checkoutProducts) => {
  const cartItemKeys = (checkoutProducts || [])
    .filter((item) => item.checkout_source === "cart" && item.cart_item_key)
    .map((item) => item.cart_item_key);
  const hasCartItems = (checkoutProducts || []).some(
    (item) => item.checkout_source === "cart"
  );

  const pendingOrder = {
    order_id: response.orderId,
    order_number: response.orderNumber || response.orderId,
    payment_method: response.paymentMethod || "vnpay",
    transaction_ref: response.transactionRef,
    lookup_token: response.lookupToken,
    amount: response.amount,
    currency: response.currency || "VND",
    status: response.orderStatus || "pending",
    cart_item_keys: cartItemKeys,
    source: hasCartItems ? "cart" : "buy_now",
    created_at: Date.now(),
  };

  sessionStorage.setItem(PENDING_ORDER_KEY, JSON.stringify(pendingOrder));
  return pendingOrder;
};

export const getPendingVNPayOrder = () => {
  const rawPendingOrder = sessionStorage.getItem(PENDING_ORDER_KEY);
  if (!rawPendingOrder) {
    return null;
  }

  try {
    const pendingOrder = JSON.parse(rawPendingOrder);
    if (
      !(pendingOrder.created_at || pendingOrder.timestamp) ||
      Date.now() - (pendingOrder.created_at || pendingOrder.timestamp) >
        PENDING_ORDER_TTL_MS
    ) {
      sessionStorage.removeItem(PENDING_ORDER_KEY);
      return null;
    }

    return pendingOrder;
  } catch {
    sessionStorage.removeItem(PENDING_ORDER_KEY);
    return null;
  }
};

export const clearPendingVNPayOrder = () => {
  sessionStorage.removeItem(PENDING_ORDER_KEY);
};
